export default "__VITE_ASSET__0c676c09__"